
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component<Index>({})
export default class Index extends Vue {
	@Getter('isSwitchingLocation', { namespace: 'auth' }) private switchingLocation!: boolean;
}
